/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ImportCSVTypes {
    ContactPerson = 10,
    Customer = 20,
    NAVInvoice = 30,
    ProductPrice = 40,
}
